export const ActivistMapContent = [
  "HOME 1887 Florida Drive, San Amaro, California, USA",
  "Toku restaurant",
  "Vegan Bitez",
  "Green World",
  "91 Roosevelt Avenue",
  "San Amaro Archives",
  "ATMs near me",
  "Arcadia Vineyard",
];
